import { FormattedMessage } from 'react-intl';

import ApprovalTimeout from './approvalTimeout/ApprovalTimeout';
import InternationalisedName from '../../multiLoanDashboard/dashboardComponents/InternationalisedName';
import messages from './DashboardApprovedHeader.messages';
import styles from './DashboardApprovedHeader.module.css';

const DashboardApprovedHeader = ({
    offer,
    offerInfo
}: {
    offer: React.ReactNode;
    offerInfo?: React.ReactNode;
}) => (
    <div className={styles.header}>
        <div
            className={styles.headerCustomerIntroduction}
            data-testid="header-name"
        >
            <FormattedMessage
                {...messages.hello}
                values={{
                    name: (
                        <span>
                            <InternationalisedName />
                        </span>
                    )
                }}
            />
        </div>

        <div className={styles.headerOffer}>{offer}</div>
        {offerInfo}
        <ApprovalTimeout />
    </div>
);

// eslint-disable-next-line import/no-default-export
export default DashboardApprovedHeader;
